/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiAttachCaseAlertsRequest,
    InternalApiAttachCaseAlertsRequestFromJSON,
    InternalApiAttachCaseAlertsRequestToJSON,
    InternalApiCaseAlert,
    InternalApiCaseAlertFromJSON,
    InternalApiCaseAlertToJSON,
    InternalApiCaseAlertPage,
    InternalApiCaseAlertPageFromJSON,
    InternalApiCaseAlertPageToJSON,
    InternalApiDetachCaseAlertsRequest,
    InternalApiDetachCaseAlertsRequestFromJSON,
    InternalApiDetachCaseAlertsRequestToJSON,
    InternalApiSortDirection,
    InternalApiSortDirectionFromJSON,
    InternalApiSortDirectionToJSON,
} from '../models';

export interface AttachCaseAlertsRequest {
    handle: string;
    internalApiAttachCaseAlertsRequest: InternalApiAttachCaseAlertsRequest;
}

export interface DetachCaseAlertsRequest {
    handle: string;
    internalApiDetachCaseAlertsRequest: InternalApiDetachCaseAlertsRequest;
}

export interface FindCaseAlertsPageRequest {
    handle: string;
    page: number;
    size: number;
    orderBy?: string;
    direction?: InternalApiSortDirection;
}

/**
 * 
 */
export class CaseAlertInternalApi extends runtime.BaseAPI {

    /**
     * Attaches alerts to a case
     */
    async attachCaseAlertsRaw(requestParameters: AttachCaseAlertsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiCaseAlert>>> {
        if (requestParameters.handle === null || requestParameters.handle === undefined) {
            throw new runtime.RequiredError('handle','Required parameter requestParameters.handle was null or undefined when calling attachCaseAlerts.');
        }

        if (requestParameters.internalApiAttachCaseAlertsRequest === null || requestParameters.internalApiAttachCaseAlertsRequest === undefined) {
            throw new runtime.RequiredError('internalApiAttachCaseAlertsRequest','Required parameter requestParameters.internalApiAttachCaseAlertsRequest was null or undefined when calling attachCaseAlerts.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/cases/{handle}/alerts`.replace(`{${"handle"}}`, encodeURIComponent(String(requestParameters.handle))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiAttachCaseAlertsRequestToJSON(requestParameters.internalApiAttachCaseAlertsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiCaseAlertFromJSON));
    }

    /**
     * Attaches alerts to a case
     */
    async attachCaseAlerts(requestParameters: AttachCaseAlertsRequest, initOverrides?: RequestInit): Promise<Array<InternalApiCaseAlert>> {
        const response = await this.attachCaseAlertsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Detaches alerts from a case (bulk support)
     */
    async detachCaseAlertsRaw(requestParameters: DetachCaseAlertsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.handle === null || requestParameters.handle === undefined) {
            throw new runtime.RequiredError('handle','Required parameter requestParameters.handle was null or undefined when calling detachCaseAlerts.');
        }

        if (requestParameters.internalApiDetachCaseAlertsRequest === null || requestParameters.internalApiDetachCaseAlertsRequest === undefined) {
            throw new runtime.RequiredError('internalApiDetachCaseAlertsRequest','Required parameter requestParameters.internalApiDetachCaseAlertsRequest was null or undefined when calling detachCaseAlerts.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/cases/{handle}/alerts`.replace(`{${"handle"}}`, encodeURIComponent(String(requestParameters.handle))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiDetachCaseAlertsRequestToJSON(requestParameters.internalApiDetachCaseAlertsRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Detaches alerts from a case (bulk support)
     */
    async detachCaseAlerts(requestParameters: DetachCaseAlertsRequest, initOverrides?: RequestInit): Promise<void> {
        await this.detachCaseAlertsRaw(requestParameters, initOverrides);
    }

    /**
     * Fetches paginated alerts associated with a case
     */
    async findCaseAlertsPageRaw(requestParameters: FindCaseAlertsPageRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiCaseAlertPage>> {
        if (requestParameters.handle === null || requestParameters.handle === undefined) {
            throw new runtime.RequiredError('handle','Required parameter requestParameters.handle was null or undefined when calling findCaseAlertsPage.');
        }

        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page','Required parameter requestParameters.page was null or undefined when calling findCaseAlertsPage.');
        }

        if (requestParameters.size === null || requestParameters.size === undefined) {
            throw new runtime.RequiredError('size','Required parameter requestParameters.size was null or undefined when calling findCaseAlertsPage.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.orderBy !== undefined) {
            queryParameters['orderBy'] = requestParameters.orderBy;
        }

        if (requestParameters.direction !== undefined) {
            queryParameters['direction'] = requestParameters.direction;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/cases/{handle}/alerts/page`.replace(`{${"handle"}}`, encodeURIComponent(String(requestParameters.handle))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiCaseAlertPageFromJSON(jsonValue));
    }

    /**
     * Fetches paginated alerts associated with a case
     */
    async findCaseAlertsPage(requestParameters: FindCaseAlertsPageRequest, initOverrides?: RequestInit): Promise<InternalApiCaseAlertPage> {
        const response = await this.findCaseAlertsPageRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
